import React, { useState, useEffect } from 'react';
// import KeepAlive from 'react-activation';
import styles from './Collection.module.less';
import classNames from 'classnames';
import SoftList from './SoftList';
import SpecialList from './SpecialList';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import Btn from '../../components/Btn/Btn';
import { logging, logPostInfo } from '../../actions/log';
import noData from '../../static/collect_blank.svg';
import { useActivate, useUnactivate, useAliveController } from 'react-activation';
import { useHistory } from 'react-router-dom';
import useLoginStatus from '../../utils/hooks/useLoginStatus';

const tabs = [
  {
    name: 'soft',
    text: '已收藏软件',
    component: SoftList,
  },
  {
    name: 'special',
    text: '已收藏专题',
    component: SpecialList,
  },
];
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
function Collection() {
  const loginStatus = useLoginStatus();
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const logInfoData = useSelector(selectLogInfo);
  const dispatch = useDispatch();
  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Mysofts_Collect`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  };
  useEffect(() => {
    setInitTime(+new Date());
    dispatch(
      logPostInfo({
        source: 'Mysofts_Collect',
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    return () => {
      leaveTimeLog();
    };
  }, []);
  useActivate(() => {
    setInitTime(+new Date());
    dispatch(
      logPostInfo({
        source: 'Mysofts_Collect',
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  const handleLogin = () => {
    window.CallNativeMethod('login'); // 未登录 调用登录弹窗
  };
  const handleClickTab = tab => () => {
    setActiveTab(tab);
    dispatch(
      logging({
        category: 'C',
        action: 'Mysofts_Collect_Tab',
        label: '',
        param2: {
          source: 'Mysofts_Collect',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: tab.name === 'soft' ? 'soft' : 'zt',
        },
      }),
    );
  };

  return (
    <div className={styles.collection}>
      <div className={styles.header}>
        {tabs.map(item => (
          <div
            key={item.name}
            className={classNames(styles.tab, { [styles.active]: item.name === activeTab.name })}
            onClick={handleClickTab(item)}
          >
            {item.text}
          </div>
        ))}
      </div>
      <div className={styles.main}>
        {loginStatus && (
          <>
            {activeTab.name === 'soft' && <SoftList loginStatus={loginStatus} />}
            {activeTab.name === 'special' && <SpecialList loginStatus={loginStatus} />}
          </>
        )}
        {!loginStatus && (
          <div className={styles.login}>
            <img src={noData} alt="" className={styles.img} />
            <div className={styles.text}>
              登录后，查看已收藏{activeTab.name === 'soft' ? '软件' : '专题'}
            </div>
            <Btn primary className={styles.btn} handleClick={handleLogin}>
              登录
            </Btn>
          </div>
        )}
      </div>
    </div>
  );
}
export default () => {
  const history = useHistory();
  const { refresh } = useAliveController();
  useEffect(() => {
    if (history.action === 'PUSH') {
      refresh('Collection');
    }
  }, []);
  return (
    // <KeepAlive name="Collection" saveScrollPosition="screen">
    <Collection />
    // </KeepAlive>
  );
};
